// extracted by mini-css-extract-plugin
export default {"container":"ShowMore-module__container__E16Xj","button":"ShowMore-module__button__Cmzxu","heading":"ShowMore-module__heading__tmU5v","caret":"ShowMore-module__caret__qE323"};